import { createStyles, IconButton, makeStyles } from "@material-ui/core";
import CheverontLeft from "@material-ui/icons/ChevronLeft";
import CheveronRight from "@material-ui/icons/ChevronRight";
import useText from "constants/text";
import React from "react";

interface PaginationListProps {
  total: number;
  per?: number;
  fetch?: any;
  fetched?: number;
  totalPages?: number;
}

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
    },
    buttons: {},
    msg: {
      color: "#c4c4c4",
    },
  })
);

export function PaginationList({ per = 20, total, fetch, totalPages = 0, fetched }: PaginationListProps) {
  const styles = useStyles();
  const text = useText();
  const [page, setPage] = React.useState(1);
  const isFirst = page === 1;
  const isLast = page === totalPages;
  const calculElements = () => {
    if (totalPages <= 1) return fetched;
    const mod = total % per;
    if (mod !== 0 && page === totalPages) {
      return (page - 1) * per + mod;
    }
    return per * page;
  };
  const fetchBack = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };
  const fetchNext = () => {
    if (page < totalPages) {
      setPage(page + 1);
    }
  };

  React.useEffect(() => {
    if (fetch) {
      fetch({
        queries: {
          page,
          limit: per,
        },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <div className={styles.root}>
      <div className={styles.msg}>
        {text.text.pagination.pagination_show} {calculElements()} {text.text.all.pagination_of} {total}
      </div>
      <div className={styles.buttons}>
        <IconButton onClick={fetchBack} disabled={isFirst}>
          <CheverontLeft />
        </IconButton>
        <IconButton onClick={fetchNext} disabled={isLast}>
          <CheveronRight />
        </IconButton>
      </div>
    </div>
  );
}
